var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"g-section"},[_c('div',{staticClass:"g-header"},[_c('h3',[_vm._v("OOD三步走万能解法，独家方法，自研套路")]),_c('p',[_vm._v("记叙文六要素:时间、地点、人物、事件的起因、经过、结果")])]),_c('div',{staticClass:"container"},[_c('img',{attrs:{"src":require("@/assets/courseComponents/ood3steps.png"),"alt":""}})])])
}]

export { render, staticRenderFns }